// One geo lookup per browser session, shared by every caller (avoids rate-limit 429s).
const CACHE_KEY = 'zi-detected-country-v1';
let pending = null;

export function detectCountryCode() {
  try {
    const cached = sessionStorage.getItem(CACHE_KEY);
    if (cached !== null) return Promise.resolve(cached || null);
  } catch (_e) { /* sessionStorage unavailable */ }
  if (!pending) {
    pending = fetch(`${process.env.REACT_APP_BACKEND_URL || window.location.origin}/api/detect-country`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        const code = (data?.country_code || '').toUpperCase();
        if (data) {
          try { sessionStorage.setItem(CACHE_KEY, code); } catch (_e) { /* ignore */ }
        }
        if (!data) pending = null;
        return code || null;
      })
      .catch(() => { pending = null; return null; });
  }
  return pending;
}
